export const LAST_JOINED_MEETING_URL_KEY = "lastJoinedMeetingUrl";
